"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const withLazy_1 = __importDefault(require("../../../common/decorators/withLazy"));
const PaymentSucceeded_1 = __importDefault(require("../Pages/PaymentSucceeded"));
const PaymentFailed_1 = __importDefault(require("../Pages/PaymentFailed"));
const BrandLayout = (0, withLazy_1.default)(/* webpackChunkName: "BrandLayout" */ (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../Pages/BrandLayout')))));
const VenueLayout = (0, withLazy_1.default)((0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require(/* webpackChunkName: "VenueLayout" */ '../Pages/VenueLayout')))));
const OldDeeplinkResolver = (0, withLazy_1.default)((0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require(/* webpackChunkName: "OldDeeplinkResolvert" */ '../Other/OldDeeplinkResolver')))));
const Routes = () => (react_1.default.createElement(react_router_dom_1.Switch, null,
    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/payment_succeeded", component: PaymentSucceeded_1.default }),
    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/payment_failed", component: PaymentFailed_1.default }),
    react_1.default.createElement(react_router_dom_1.Redirect, { exact: true, from: "/venues/367-robinson-club-khao-lak/activities", to: "/" }),
    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/", component: BrandLayout }),
    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/venues", component: BrandLayout }),
    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/profile", component: BrandLayout }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "/page/:name", component: BrandLayout }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "/directory/:type/:name", component: BrandLayout }),
    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/checkin/:venueId-:venueSlug", component: OldDeeplinkResolver }),
    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/venues/:venueId-:venueSlug/:type/:itemId-:itemSlug", component: OldDeeplinkResolver }),
    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/venues/:venueId-:venueSlug/:type", component: OldDeeplinkResolver }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "/:slug", component: VenueLayout })));
exports.default = Routes;
